import type { ReactNode } from 'react';
import type { GetManyEventsListItem } from '../../../server/types/infer-trpc-types.ts';
import { EventCard } from './event-card.tsx';

type Props = {
    event: GetManyEventsListItem;
    date: string;
};

export function OverlayEventCard({ event, date }: Props): ReactNode {
    return <EventCard date={date} event={event} className="shadow-2xl" />;
}
